import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { IMemberListData, IMemberShipType } from "../../../exports/interfaces";
import { TextField } from "@mui/material";
import { toWords } from "number-to-words";

const TableFilter = ({
  listMemberData,
  setFilteredData,
  setCurrentPage,
  allMembershipType,
  selectedStatus,
  setSelectedStatus,
}: {
  listMemberData: IMemberListData[];
  setFilteredData: React.Dispatch<React.SetStateAction<IMemberListData[]>>;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  allMembershipType: IMemberShipType[];
  selectedStatus: string[];
  setSelectedStatus: Dispatch<SetStateAction<string[]>>;
}) => {
  const [email, setEmail] = useState("");
  const [location, setLocation] = useState("");
  const [membershipType, setMembershipType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  useEffect(() => {
    let data = listMemberData;

    // Apply status filter first
    if (selectedStatus.length > 0) {
      data = data.filter((m) => selectedStatus.includes(m.attributes?.Status));
    } else {
      // Pending → Approved → Others
      data.sort((a, b) => {
        // Highest priority: Approved + Payment Received
        const aPriority =
          a.attributes?.Status === "Approved" && a.attributes?.Payment_Received
            ? 0
            : 1;

        const bPriority =
          b.attributes?.Status === "Approved" && b.attributes?.Payment_Received
            ? 0
            : 1;

        if (aPriority !== bPriority) {
          return aPriority - bPriority;
        }

        // Normal ordering
        const order: Record<string, number> = {
          Pending: 1,
          Approved: 2,
        };

        const aOrder = order[a.attributes?.Status] || 3;
        const bOrder = order[b.attributes?.Status] || 3;

        return aOrder - bOrder;
      });
    }

    // Apply table filters
    const filtered = data.filter((member) => {
      const attrs = member.attributes;

      const emailMatch =
        email === "" ||
        attrs.Email?.toLowerCase().includes(email.toLowerCase());

      const locationMatch = location === "" || attrs.Country === location;

      const membershipMatch =
        membershipType === "" || attrs.Type_Of_Membership === membershipType;

      const membershipDate = new Date(attrs.Membership_Expiry);

      const fromMatch = fromDate === "" || membershipDate >= new Date(fromDate);

      const toMatch = toDate === "" || membershipDate <= new Date(toDate);

      return (
        emailMatch && locationMatch && membershipMatch && fromMatch && toMatch
      );
    });

    setFilteredData(filtered);
    setCurrentPage(1);
  }, [
    email,
    location,
    membershipType,
    fromDate,
    toDate,
    listMemberData,
    selectedStatus,
    setFilteredData,
    setCurrentPage,
  ]);

  const handleReset = () => {
    setEmail("");
    setLocation("");
    setMembershipType("");
    setFromDate("");
    setToDate("");
    setSelectedStatus([]);
    setFilteredData(listMemberData);
    setCurrentPage(1);
  };
  return (
    <>
      <div className="row" style={{ padding: "0px 10px" }}>
        <div className="col-xl-3">
          <div
            className="become-volunteer__input"
            style={{ marginBottom: "unset", marginTop: "10px" }}
          >
            <input
              type="text"
              placeholder="Email ID"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
        </div>
        <div className="col-xl-2">
          <div
            className="become-volunteer__input"
            style={{ marginBottom: "unset", marginTop: "10px" }}
          >
            <select
              name="Location All"
              className="become-volunteer__select"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
            >
              <option value="" disabled>
                Location All
              </option>
              <option value="Nepal">Nepal</option>
              <option value="India">India</option>
            </select>
          </div>
        </div>
        <div className="col-xl-2">
          <div
            className="become-volunteer__input"
            style={{ marginBottom: "unset", marginTop: "10px" }}
          >
            <select
              name="Membership Type"
              className="become-volunteer__select"
              value={membershipType}
              onChange={(e) => setMembershipType(e.target.value)}
            >
              <option value="" disabled>
                Membership Type
              </option>
              {allMembershipType?.map((membership) => (
                <option
                  value={`${membership.attributes.Title} ${
                    membership.attributes.Expire_In_Yrs === 1
                      ? "(ANNUALLY)"
                      : membership.attributes.Expire_In_Yrs === 0
                        ? ""
                        : `(${toWords(
                            membership.attributes.Expire_In_Yrs,
                          ).toUpperCase()} YEARS)`
                  }`}
                >
                  {membership.attributes.Title}{" "}
                  {membership.attributes.Expire_In_Yrs === 1
                    ? "(ANNUALLY)"
                    : membership.attributes.Expire_In_Yrs === 0
                      ? ""
                      : `(${toWords(
                          membership.attributes.Expire_In_Yrs,
                        ).toUpperCase()} YEARS)`}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="col-xl-2">
          <TextField
            label="From"
            type="date"
            fullWidth
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            sx={{
              marginTop: "10px",
              "& .MuiInputBase-root": {
                backgroundColor: "#f4f1ec",
                borderRadius: "8px",
              },
              "& .Mui-focused .MuiInputBase-input": {
                color: "#727272",
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#727272",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
              },
              "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
              },
              "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "transparent",
                },
            }}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </div>
        <div className="col-xl-2">
          <TextField
            label="To"
            type="date"
            fullWidth
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            sx={{
              marginTop: "10px",
              "& .MuiInputBase-root": {
                backgroundColor: "#f4f1ec",
                borderRadius: "8px",
              },
              "& .Mui-focused .MuiInputBase-input": {
                color: "#727272",
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#727272",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
              },
              "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
              },
              "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "transparent",
                },
            }}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </div>
        <div className="col-xl-1">
          <div style={{ display: "flex", gap: "5px", marginTop: "10px" }}>
            {/* <button
              className="thm-btn become-volunteer__btn"
              onClick={handleSearch}
            >
              <i className="icon-magnifying-glass1"></i>
            </button> */}
            <button
              className="thm-btn become-volunteer__btn"
              style={{ backgroundColor: "#ffa415" }}
              onClick={handleReset}
            >
              <i className="icon-loop2"></i>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default TableFilter;
